export const emojis = [
  "🐵",
  "🐒",
  "🦍",
  "🐶",
  "🐕",
  "🐩",
  "🐺",
  "🦊",
  "🐱",
  "🐈",
  "🦁",
  "🐯",
  "🐅",
  "🐆",
  "🐴",
  "🐎",
  "🦌",
  "🦄",
  "🐮",
  "🐂",
  "🐃",
  "🐄",
  "🐷",
  "🐖",
  "🐗",
  "🐽",
  "🐏",
  "🐑",
  "🐐",
  "🐪",
  "🐫",
  "🐘",
  "🦏",
  "🐭",
  "🐁",
  "🐀",
  "🐹",
  "🐰",
  "🐇",
  "🐿",
  "🦇",
  "🐻",
  "🐨",
  "🐼",
  "🐾",
  "🦃",
  "🐔",
  "🐓",
  "🐣",
  "🐤",
  "🐥",
  "🐦",
  "🐧",
  "🕊",
  "🦅",
  "🦆",
  "🦉",
  "🐸",
  "🐊",
  "🐢",
  "🦎",
  "🐍",
  "🐲",
  "🐉",
  "🐳",
  "🐋",
  "🐬",
  "🐟",
  "🐠",
  "🐡",
  "🦈",
  "🐙",
  "🐚",
  "🦀",
  "🦐",
  "🦑",
  "🦋",
  "🐌",
  "🐛",
  "🐜",
  "🐝",
  "🐞",
  "🕷",
  "🦂",
  "🦟",
];
